let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwPcN")).then(() => parcelRequire('gAsmN'));